import React from 'react';
import { useState, useEffect } from 'react';
import { Box} from '@mui/material';

import { stateValuesDos } from '../../../Utils/Utils';
import UpdateBranchForm from '../../../Components/Branches/UpdateBranchForm';
import LoadingBackDrop from '../../../Components/LoadingBackDrop';
import SnackBar from '../../../Components/SnackBar';
import DialogeConfirmationBoxBranch from '../../../Components/Branches/DialogeBox/DialogeConfirmationBoxBranch';


import { getAllInspectorCompanies,patchInspectorBranch } from '../../Services/InspectorAPI';

export default function UpdateInspectionAgencyBranchForm() {

  let hqBusinessType = "Inspector";
  let confirmationType = "Update";
  let titleAction = "Updating";

  const [companiesArray, setCompaniesArray] = useState([]);

  const [inputStateValue, setInputStateValue] = React.useState('');
  const [stateValue, setStateValue] = React.useState(null);

  const [viewBranchSelect, setViewBranchSelect] = useState("none");
  const [viewBranchFields, setViewBranchFields] = useState("none");


  const [confirmationDialogeBoxOpen, setConfirmationDialogeBoxOpen] = useState(false);
  const [openLoadingBackDrop, setOpenLoadingBackdrop] = useState(false);

  /**
   * SNACK BAR States
   */
  const[alertType,setAlertType] = useState("success");
  const[alertMessage, setAlertMessage]=useState("")
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  

    // auedexa
  const [companyObjct, setCompanyObjct] = useState({
      hq_id:"",
      hq_company_name:"",
      hq_company_type:"Bank",
      hq_company_address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
      hq_phone:"",
      hq_email:"",
      branches:[]
  });
  const[branchObjct, setBranchObjct] = useState( {
      branch_id:"",
      branch_name:"",
      company_association:{hq_id:""},
      branch_address:{
          address:"",
          address_two:"",
          city:"",
          state:"",
          zip:""
      },
      branch_phone:"",
      branch_email:"",
      branch_employees:[]
  });
    
  const[branchObjectBeforeUpdate, setBranchObjectBeforeUpdate] = useState({
    branch_id:"",
    branch_name:"",
    company_association:{hq_id:""},
    branch_address:{
        address:"",
        addressTwo:"",
        city:"",
        state:"",
        zip:""
    },
    branch_phone:"",
    branch_email:"",
    branch_employees:[]
  });

  const [errorObject,setErrorObject] = useState({
    branch_id:false,
    branch_name:false,
    company_association:{hq_id:""},
    branch_address:{
        address:false,
        addressTwo:false,
        city:false,
        state:false,
        zip:false
    },
    branch_phone:false,
    branch_email:false,
    branch_employees:[]

  });

  let initialCompanyObject={
    hq_id:"",
    hq_company_name:"",
    hq_company_type:"Inspector",
    hq_company_address:{
      address:"",
      address_two:"",
      city:"",
      state:"",
      zip:""
  },
    hq_phone:"",
    hq_email:"",
    branches:[]
  };

  let initialBranchObjct = {
    branch_id:"",
    branch_name:"",
    company_association:{hq_id:""},
    branch_address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
    branch_phone:"",
    branch_email:"",
    branch_employees:[]
  };

  function handleConfirmDialogeBoxClose(){
    setConfirmationDialogeBoxOpen(false);
  };

  function handleLoadingClose(){
    setOpenLoadingBackdrop(false);
  };

  /**
   * OPENS THE SNACKBAR
   */
  const handleSnackBarOpen = () => {
    setSnackBarOpen(true);
  };
    
  /**
   * CLOSES THE SNACK BAR
   */
  const handleSnackBarClosed = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  };

  useEffect(()=>{
    // get all the inspector companies
    const fetchInspectors = async () => {
      const allInspectorCompaniesData = await getAllInspectorCompanies();
      console.log(allInspectorCompaniesData.data)
      setCompaniesArray(allInspectorCompaniesData.data);
      return allInspectorCompaniesData.data
    }
    fetchInspectors();
  
  },[]);
    
  function handleChoosenHQChange(e){

    let hq_id = e.target.value;
    let choosenHq = findHqCompany(hq_id);
  
    if(choosenHq){
      setCompanyObjct(choosenHq);
      setViewBranchSelect("block");
      setBranchObjct(initialBranchObjct);
        
    }else{
      console.log("cant find");
      setViewBranchSelect("none");
      setViewBranchFields("none");
      setCompanyObjct(initialCompanyObject);
      setBranchObjct(initialBranchObjct);
    }
    
  };

  const findHqCompany = (hq_id) =>{
    let foundHq = companiesArray.filter((hq) => 
        hq.hq_id === hq_id
    );
    if (foundHq.length === 1){
        return foundHq[0];
    }else{
        return null;
    }
  };
    
    
  function handleChoosenBranchChange(e){

    let branch_id = e.target.value;

    if(branch_id === null || branch_id === ""){

      setViewBranchFields("none");
      setBranchObjct(initialBranchObjct);
      setBranchObjectBeforeUpdate(initialBranchObjct);
    }else{
      
      let branchToUpdate = getBranch(branch_id);
      branchToUpdate.company_association = {hq_id:companyObjct.hq_id}
      setViewBranchFields("block");
      setBranchObjct(branchToUpdate);
      setBranchObjectBeforeUpdate(branchToUpdate);
  
      let branchAddressState = branchToUpdate.branch_address.state;
  
      let stateOpt = stateValuesDos.filter((opt) => 
          opt.index === branchAddressState
      );
      
      setStateValue(stateOpt[0]);
      setInputStateValue(stateOpt[0].index);
    }
  }

  const getBranch = (branch_id) =>{

    let foundBranch = companyObjct.branches.filter((branch) => 
        branch.branch_id === branch_id
    );
    if (foundBranch.length === 1){
        return foundBranch[0];
    }else{
        return null;
    }
  }
    
    
      function handleNameChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_name: e.target.value
        });
      };
      
      function handleEmailChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_email: e.target.value
        });
      };
      
      function handlePhoneChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_phone: e.target.value
        });
      };
      
      function handleAddressChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_address:{
            ...branchObjct.branch_address,
            address:e.target.value
          }
        });
      };
      
      
      function handleAddressTwoChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_address:{
            ...branchObjct.branch_address,
            address_two:e.target.value
          }
        });
      };
      
      function handleCityChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_address:{
            ...branchObjct.branch_address,
            city:e.target.value
          }
        });
      };
      
      function handleStateChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_address:{
            ...branchObjct.branch_address,
            state:e.index
          }
        });
      };
      
      function handleZipChange(e){
        setBranchObjct({
          ...branchObjct,
          branch_address:{
            ...branchObjct.branch_address,
            zip:e.target.value
          }
        });
      };



  /**
   * Error Validating The Form
   */
  function formErrorValidation(e){
    e.preventDefault();
    let foundError = false;

    if(branchObjct.branch_name === "" || branchObjct.branch_name === null ){
      setErrorObject({
        ...errorObject,
        branch_name:true
      });
      foundError = true;
    };

    if(!foundError){
      testConfirmAddCompanyConfirmationBox();
    }
  }

  /***
   * Handles the submit button from form component
   */
  function testConfirmAddCompanyConfirmationBox(){
    setConfirmationDialogeBoxOpen(true)
  }


  /***
   * Handles the response from the confirmation dialoge box
   */
  function dialogeConfirmationBoxAnswerHandle(resp){
    console.log("handling answer");
    console.log("The answer is === " + resp);
    if(resp === "Agree"){
      setConfirmationDialogeBoxOpen(false);
      setOpenLoadingBackdrop(true);
      submitBranchUpdate();
    }else{
      setConfirmationDialogeBoxOpen(false);
    }
  };

  /***
   * Handles adding a new branch
   */
  async function submitBranchUpdate(){
    let resp = await patchInspectorBranch(branchObjct);
    if (resp.error){
      setAlertType("error");
      setAlertMessage(`There was an error ${titleAction}ing the ${hqBusinessType} Branch.`);
    }else{
      setAlertType("success");
      setAlertMessage(`The ${hqBusinessType} branch has been successfully updated.`);
      handleSnackBarOpen();
      addUpdatedItemToArray();
      clearForm();
    }
    
  };


  /**
   * Replaces the updated item with the newly updated item
   */
  function addUpdatedItemToArray(){
    let copiedCompaniesArray = [...companiesArray];
    let clonedCompany = {...companyObjct}
    const modifiedCompanies = copiedCompaniesArray.map(obj => {

      if (obj.hq_id === clonedCompany.hq_id) {
          console.log("found it");
          return clonedCompany;
      }
      return obj;
  });
    setCompaniesArray(modifiedCompanies);
  };


  /**
   * Resets the companyObject so the form is cleared.
   */
  function clearForm(){
    // setCompanyObjct(initialBranchObjct);
    setBranchObjct(initialBranchObjct);
    setBranchObjectBeforeUpdate(initialBranchObjct);
  };
    
    

  return (
    <Box>
        <UpdateBranchForm
          errorValidator={errorObject}
          addWhatBranchTitle={hqBusinessType}
          addWhatCompanyTitle = {hqBusinessType}
          hqCompaniesToMap = {companiesArray}

          hqCompanyObject={companyObjct}
          branchObjct = {branchObjct}

          handleChoosenHQ = {handleChoosenHQChange} // HANDLES THE CHANGE OF THE SELECT HQ INPUT
          handleChoosenBranchChange = {handleChoosenBranchChange}

        

          viewBranchSelect={viewBranchSelect}
          viewBranchFields={viewBranchFields}
          handleNameChange={handleNameChange}
          handleEmailChange={handleEmailChange}
          handlePhoneChange={handlePhoneChange}
          handleAddressChange={handleAddressChange}
          handleAddressTwoChange={handleAddressTwoChange}
          handleCityChange={handleCityChange}
          handleStateChange={handleStateChange}

          inputStateValue={inputStateValue}
          setInputStateValue={setInputStateValue}
          stateValue={stateValue}

          setStateValue={setStateValue}
          handleZipChange={handleZipChange}
          submitNewBranch={formErrorValidation}
        />
        <DialogeConfirmationBoxBranch
          confirmationType={confirmationType}
          titleAction={titleAction}

          intialUpdatedObject={branchObjectBeforeUpdate}
          updatedObject={branchObjct}

          addWhatCompanyType={hqBusinessType}
          hqCompanyObject={companyObjct}
          branchObject={branchObjct}
          confirmationDialogeBoxOpen={confirmationDialogeBoxOpen}
          dialogeConfirmationBoxAnswerHandle={dialogeConfirmationBoxAnswerHandle}
          handleConfirmDialogeBoxClose={handleConfirmDialogeBoxClose}
        />
        <LoadingBackDrop
          openLoadingBackDrop={openLoadingBackDrop}
          handleLoadingClose={handleLoadingClose}
        />
        <SnackBar
          handleSanckBarOpen={handleSnackBarOpen}
          handleSnackBarClosed={handleSnackBarClosed}
          snackBarState = {snackBarOpen}
          alertType={alertType}
          alertMessage={alertMessage}
        />
    </Box>
  )
}


